export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** Any non-alphanumeric counts as a special character (e.g. `.`, `!`, `#`). */
export const PASSWORD_SPECIAL_CHAR_REGEX = /[^a-zA-Z0-9]/;

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;

export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character';

export const URL_REGEX = /^https:\/\/.+\.[a-z]{2,}\/.{2,}$/i;
export const DOMAIN_REGEX = /^[A-Za-z0-9-]+$/;
